import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const messagesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAppMessages: builder.query({
      query: (id) => (config.GetCommunication || "") + id,
    }),
    loadAppAdhocMessages: builder.query({
      query: (id) => (config.GetAdhocMessages || "") + id,
    }),
    loadAppMsgList: builder.query({
      query: (id) => (config.GetMessages || "") + id,
      providesTags: (result, error, id) => [{ type: "AppMsgList", id }],
    }),
    updateMessageRead: builder.mutation({
      query: ({ id, userId }) => ({
        url: (config.UpdateMessageReadStatus || "") + id + "&perfId=" + userId,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "AppMsgList", id }],
    }),
    addAppNewMessage: builder.mutation({
      query: (data) => ({
        url: config.AddNewMessage || "",
        method: "POST",
        body: data,
      }),
    }),
    addAppMessage: builder.mutation({
      query: (data) => ({
        url: config.AddMessage || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, data) => {
        let id;
        if (data instanceof FormData) {
          try {
            const comm = JSON.parse(data.get("communication"));
            id = comm?.id;
          } catch (e) {}
        }
        return id ? [{ type: "AppMsgList", id }] : [];
      },
    }),
    addAppAdhocNewMessage: builder.mutation({
      query: (data) => ({
        url: config.AddAdocMessage || "",
        method: "POST",
        body: data,
      }),
    }),
    loadAppTimerMessages: builder.query({
      query: (id) => (config.GetTimerMessages || "") + id,
    }),
  }),
});

export const {
  useLoadAppMessagesQuery,
  useLazyLoadAppMessagesQuery,
  useLoadAppAdhocMessagesQuery,
  useLazyLoadAppAdhocMessagesQuery,
  useLoadAppMsgListQuery,
  useLazyLoadAppMsgListQuery,
  useUpdateMessageReadMutation,
  useAddAppNewMessageMutation,
  useAddAppMessageMutation,
  useAddAppAdhocNewMessageMutation,
  useLoadAppTimerMessagesQuery,
  useLazyLoadAppTimerMessagesQuery,
} = messagesApiSlice;
